import { render } from "./Rtts.vue?vue&type=template&id=4dcd726e&scoped=true"
import script from "./Rtts.vue?vue&type=script&lang=js"
export * from "./Rtts.vue?vue&type=script&lang=js"

import "./Rtts.vue?vue&type=style&index=0&id=4dcd726e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4dcd726e"

export default script